import { useMemo } from "react";

import { observer } from "mobx-react-lite";

import { Row } from "@/components/expression/inline-node/Row";
import {
  applyComputedDimming,
  groupNodesWithAttachments,
} from "@/components/expression/inline-node/utils";
import { useNodeStyle } from "@/components/expression/utils/NodeStyleProvider";

import type { InlineNodeComponentProps } from "@/components/expression/inline-node/types";
import type { RowNode } from "@/components/expression/inline-node/wrapping/types";

export const SingleRowLayout = observer(function SingleRowLayout({
  node,
  doc,
  nodes,
  withFillers,
  className,
}: Omit<InlineNodeComponentProps, "availableWidth">) {
  const { renderContext, computedSplit } = useNodeStyle();
  const items = useMemo(
    () => applyComputedDimming(groupNodesWithAttachments(nodes), computedSplit, renderContext),
    [nodes, computedSplit, renderContext],
  );
  const content: RowNode[] = [{ kind: "items", items, parentInline: node }];

  return (
    <Row
      node={node}
      doc={doc}
      content={content}
      isFirstRow
      isLastRow
      withFillers={!!withFillers}
      className={className}
    />
  );
});
